import styled from 'styled-components';
import {tokensForThemeProvider} from '@forecast-it/design-system';
import {ConfigImportStatus} from '../xero/AppXeroStyled';

const {color} = tokensForThemeProvider.sky.sys;

/* The single-organisation form of the Organization field (spec AC2): the same label the dropdown
   carries, with the organisation's name as plain text beneath it, in the space the dropdown
   would take. */
export const ConfigImportOrganisation = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	.qbo-config-organisation-label {
		font-weight: 500;
	}
`;

/* An option's checkbox sits inside its label (the shared Checkbox drops id, so htmlFor cannot reach
   it). ConfigImportRow styles every label inside it with a left margin, written for a label that
   sits beside its control; the doubled ampersand outranks that rule so this label starts flush and
   lays out the checkbox and the text itself - the same look as before. */
export const ConfigImportOptionLabel = styled.label`
	&& {
		margin-left: 0;
		display: inline-flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
		line-height: 18px;
	}
`;

/* One option: its row, then - on a failure with a known cause - the message on its own line under it
   (design: indented to the label, max 720px wide). */
export const ConfigImportOption = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

/* The status after the label. data-tone, not a prop, so the colour is a plain attribute selector and
   the tests can read the tone off the DOM. */
export const ConfigImportStatusText = styled(ConfigImportStatus)`
	&[data-tone='error'] {
		color: ${color.text.semantic.error};
	}
	&[data-tone='success'] {
		color: ${color.text.semantic.success};
	}
`;

/* The message under a failed option (spec 032, What a row shows). The 32px indent lines it up with the
   label text after the checkbox. */
export const ConfigImportMessage = styled.p`
	&& {
		margin: 0 0 0 32px;
		max-width: 720px;
		color: ${color.text.semantic.error};
		font-size: 12px;
		line-height: 18px;
	}
`;
